import { Team, RoundAnswer, Song, TimelineCard } from '../types';

// Score Calculation - Simple system: 1 point per correct answer
// Year correct: 1 point
// Artist correct: 1 point  
// Title correct: 1 point
// Max: 3 points per song
export const calculateScore = (
  team: Team,
  answer: RoundAnswer,
  currentSong: Song
): { newScore: number; earnedToken: boolean; cardAdded: boolean; pointsEarned: number } => {
  let pointsEarned = 0;
  
  // 1 point for each correct answer
  if (answer.yearCorrect) pointsEarned++;
  if (answer.artistCorrect) pointsEarned++;
  if (answer.titleCorrect) pointsEarned++;

  // Card is added to timeline if year was correct
  const cardAdded = answer.yearCorrect;
  
  // Token earned if artiest + titel both correct (legacy compatibility)
  const earnedToken = answer.artistCorrect && answer.titleCorrect && team.tokens < 5;

  return {
    newScore: team.score + pointsEarned,
    earnedToken,
    cardAdded,
    pointsEarned
  };
};

// Timeline Management
export const insertCardInTimeline = (
  timeline: TimelineCard[],
  newCard: TimelineCard
): TimelineCard[] => {
  const newTimeline = [...timeline];
  const insertIndex = newTimeline.findIndex(card => card.year > newCard.year);
  const position = insertIndex === -1 ? newTimeline.length : insertIndex;
  newTimeline.splice(position, 0, newCard);
  return newTimeline;
};

export const isTimelineCorrect = (timeline: TimelineCard[]): boolean => {
  for (let i = 1; i < timeline.length; i++) {
    if (timeline[i].year < timeline[i - 1].year) {
      return false;
    }
  }
  return true;
};

// Token Management
export const canUseToken = (team: Team): boolean => {
  return team.tokens > 0;
};

export const canBuyCard = (team: Team): boolean => {
  return team.tokens >= 3;
};

export const canEarnToken = (team: Team): boolean => {
  return team.tokens < 5;
};

// Winner Detection - highest score after all rounds
export const checkWinner = (teams: Team[]): Team | null => {
  // Return null if no teams or game still in progress
  if (teams.length === 0) return null;
  // No automatic winner - admin decides when game ends
  return null;
};

export const getLeaderboard = (teams: Team[]): Team[] => {
  return [...teams].sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    return b.tokens - a.tokens; // Tie-breaker
  });
};

// Token Distribution by Difficulty
export const getInitialTokens = (difficulty: 'original' | 'pro' | 'expert'): number => {
  switch (difficulty) {
    case 'original':
      return 2;
    case 'pro':
      return 5;
    case 'expert':
      return 3;
    default:
      return 2;
  }
};
